// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0977bd2","453":"c80e6c7c","644":"5770fbec","745":"ec4ad2b7"}[chunkId] + ".chunk.js";
};